var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1h13.106v4.3c-1.16.444-3.604 1.843-4.096 3.891-.614 2.56 0 5.325 2.867 6.964 2.867 1.638 4.812 1.433 5.53 3.276.716 1.843 0 3.788-2.56 3.584-2.048-.164-2.833-2.458-2.97-3.584l-4.3.921c-.137.309-.041 1.455 1.433 3.585 1.475 2.13 3.345 2.799 4.096 2.867V31c-1.57-.239-5.488-1.413-8.6-4.198C2.391 24.017 1.204 20.25 1 18.713V1z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.918 5.3V1c1.604.785 5.079 2.54 6.143 3.276 1.333.922 7.476 5.94 5.53 15.154-1.556 7.372-8.77 10.785-12.184 11.57v-4.198c.478-.17 1.782-.82 3.174-2.048 1.74-1.536 2.048-5.324 1.024-7.576-1.024-2.253-5.222-3.584-6.758-4.506-1.535-.921-2.457-2.867 0-3.48 1.966-.492 3.482 1.228 3.994 2.15l3.276-2.15c-.136-.342-.635-1.23-1.536-2.049-.9-.819-2.15-1.57-2.662-1.843z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLusd);
export default __webpack_public_path__ + "static/media/LUSD.30a3da6df2864442e70fc0815877e7a4.svg";
export { ForwardRef as ReactComponent };